import IconCopy from "assets/img/icon-copy.svg?react"

import { FC, PropsWithChildren } from "react"

import { Grid, GridItem } from "components/Grid"
import Button from "components/Button/Button"
import useCopyToClipboard from "./useCopyToClipboard"

interface ICopyToClipboardProps {
    copyText: string
}

const CopyToClipboard: FC<PropsWithChildren<ICopyToClipboardProps>> = ({
    copyText,
    children,
}) => {
    const copyToClipboard = useCopyToClipboard()

    return (
        <Grid columns="minmax(0, max-content) minmax(max-content, auto)"
            alignItems="center">
            <GridItem>
                {children}
            </GridItem>
            <Button
                theme="link"
                onClick={() => copyToClipboard({ text: copyText })}
                icon={<IconCopy />}
                size="small"
            />
        </Grid>
    )
}

export default CopyToClipboard
